export const AppConfig = {
  FORM_IDENTIFIER_MIN_LENGTH: 4,
  COLORS: ['#E16100', '#964100', '#4B2000', '#000000', '#C85600', '#7D3600', '#321600', '#AF4B00', '#642B00', '#190B00']
};
